export const getCurrentYear = (): number => new Date(Date.now()).getFullYear();
